export interface IRequestHeaders {
	[key: string]: string;
}
